import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import { Col, Container, Row, Tab, Tabs } from 'react-bootstrap';
import * as DateFns from 'date-fns';

import { CURRENT, CUSTOM, FILTER_GLOBAL_KEYS, FILTER_KEYS, LEAGUE } from '../../config/constants';
import { findLeagueOptionFilter, findVenueOptionFilter, modifyTime } from '../../helpers';
import Navbar from '../Navbar/NavBar';
import { HealthTimeSlider } from '../Shared/Filters';
import VenueSelector from '../Shared/Filters/VenueSelector/VenueSelector';
import { useInterval, useRouter } from '../../helpers/customHooks';
import HealthTab from '../../components/Health/HealthTab';
import EntityTab from '../../components/Health/EntityTab';
import DPacketsTab from '../../components/Health/DPacketsTab';
import TimeSelector from '../Shared/TimeSelector';
import SimpleSelector from '../Shared/Filters/SimpleSelector';
import { useEntitiesDispatch, useFiltersDispatch, useFiltersState } from '../../store/hooks';
import { SimpleSelectorItem } from '../Shared/Filters/SimpleSelector/types';
import { HealthTimeSliderFilterData } from '../Shared/Filters/HealthTimeSlider/types';

import './Health.scss';
import FiltersEntitiesPage from 'components/Entities/FiltersEntitiesPage';
import Loader from 'components/Shared/Loader';

export default () => {

  const { search, specificScope, params, history } = useRouter();
  const { tab }: { tab?: string } = params;
  const {
    [FILTER_KEYS.TIME_SLIDER]: timeSlider,
    [FILTER_GLOBAL_KEYS.VENUES]: venues,
    [FILTER_KEYS.VENUE]:venue
  } = useFiltersState(specificScope, FILTER_KEYS.TIME_SLIDER, FILTER_GLOBAL_KEYS.VENUES, FILTER_KEYS.VENUE);
  const { changeFilterData: updateFilters } = useFiltersDispatch();
  const leagueParam = new URLSearchParams(search).get('league');
  const typeParam = new URLSearchParams(search).get('type');
  const teamParam = new URLSearchParams(search).get('teamId');
  const [showFilter, setShowFilter] = useState(-1);
  const close = () => setShowFilter(-1);
  const selectedDate = timeSlider && timeSlider.selectedTime ? new Date(timeSlider.selectedTime) : new Date();
  const [currentDate, setCurrentDate] = useState(selectedDate);
  const [currentDateUtc, setCurrentDateUtc] = useState(new Date((selectedDate).toISOString().substr(0, 23)));
  const rendersCounter = useRef(0);
  const { getEntities, getEntities: loadEntities, } = useEntitiesDispatch();
  const [showMessg, setShowMessg] = useState(false);
  useEffect(() => {
    rendersCounter.current++;
    if(rendersCounter.current > 1 && venue !== undefined){
      setShowMessg(false);
    }else{
      setShowMessg(true);
    }
  }, [venue]);
  useEffect(() => {
    const currentDate = new Date().getTime();
    updateFilters({
      status: CURRENT,
      selectedTime: currentDate,
      rangeTimeStart: currentDate,
      rangeTimeEnd: currentDate
    } as HealthTimeSliderFilterData, FILTER_KEYS.TIME_SLIDER)();
  }, []);
  useEffect(() => {
    updateFilters(findLeagueOptionFilter(leagueParam, typeParam) as SimpleSelectorItem, LEAGUE.filterKey)();
    updateFilters(findVenueOptionFilter(venues, leagueParam, typeParam, teamParam) as SimpleSelectorItem, FILTER_KEYS.VENUE)();
  }, [search]);
  useEffect(() => {
    if (timeSlider && timeSlider.selectedTime) {
      const selectedDate = timeSlider && timeSlider.selectedTime ? new Date(timeSlider.selectedTime) : new Date();
      setCurrentDate(selectedDate);
      setCurrentDateUtc(new Date((selectedDate).toISOString().substr(0, 23)));
    }
  }, [timeSlider]);
  useInterval(() => {
    if (timeSlider && timeSlider.status === CURRENT) {
      const now = new Date();
      setCurrentDate(now);
      setCurrentDateUtc(new Date(now.toISOString().substr(0, 23)));
    }
  }, timeSlider && timeSlider.status === CURRENT ? 1000 : null);

  const forceUpdateHandler = useCallback(() => {
    if (timeSlider && timeSlider.status === CURRENT) {
      const currentDate = new Date().getTime();
      updateFilters({
        status: CURRENT,
        selectedTime: currentDate,
        rangeTimeStart: currentDate,
        rangeTimeEnd: currentDate
      } as HealthTimeSliderFilterData, FILTER_KEYS.TIME_SLIDER)();
    } else {
      updateFilters({ ...timeSlider } as HealthTimeSliderFilterData, FILTER_KEYS.TIME_SLIDER)();
    }
  }, [timeSlider, updateFilters]);

  return (
    <Fragment>
      <Navbar />
      <Container className="container-00">
        <h4 className="h-t">Health</h4>
        <Row>
          <Col lg={12} xs={12}>
            <Tabs defaultActiveKey="venue" id="uncontrolled-tab-example">
              <Tab eventKey="venue" title="Venue">
                <div className="head-filters-01">
                <FiltersEntitiesPage loadData={loadEntities} showMessg={showMessg} specificScope={specificScope}/>
                  <HealthTimeSlider />
                  <div className="utc-00 utc-editable">
                    <b>Local Time:</b>
                    <TimeSelector
                      time={currentDate}
                      applyChanges={(hours: number, minutes: number, seconds: number, am: boolean) => {
                        const localNewTime = modifyTime(currentDate, hours, minutes, seconds, am).getTime();
                        updateFilters({
                          status: CUSTOM,
                          selectedTime: localNewTime,
                          rangeTimeStart: localNewTime,
                          rangeTimeEnd: localNewTime
                        } as HealthTimeSliderFilterData, FILTER_KEYS.TIME_SLIDER)();
                      }}
                    />
                  </div>
                  <div className="utc-00">
                    <b>UTC:</b>
                    {DateFns.format(currentDateUtc, 'hh:mm:ssa')}
                  </div>
                  <div className="utc-00" onClick={forceUpdateHandler}>
                    <i className="mdi mdi-refresh" />
                  </div>
                </div>
                <div className="health-body" style={tab === 'health' ? { height: '680px' } : undefined}>
                  {
                    showMessg ?
                    <>
                    <Loader forceMessage='Please select a Venue.'/>
                    </>
                    : 
                    <Tabs
                    defaultActiveKey={tab} id="uncontrolled-tab-example" mountOnEnter unmountOnExit
                    onSelect={(e) => {
                      history.push({ pathname: '/health/' + e });
                    }}
                  >
                    <Tab eventKey="health" title="Health">
                      <HealthTab />
                    </Tab>
                    <Tab eventKey="entity" title="Entity">
                      <EntityTab />
                    </Tab>
                    <Tab eventKey="packets" title="D Packets">
                      <DPacketsTab />
                    </Tab>
                  </Tabs>
                  }
                </div>
              </Tab>
              {/*<Tab eventKey="health" title="Hub Health">*/}
              {/*</Tab>*/}
            </Tabs>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};
